import React, {useContext} from "react";
import {Image} from "../Image/Image";
import ContactModalButton from "../Contact/ContactModalButton";
import {AppContext, ROOT_DIR} from "../../App";

function HomeArticle({title, description, city, postalCode, position, cityDescription}) {
    const {isMobile} = useContext(AppContext);

    const imageSource = ROOT_DIR + "/images/home/agence-immobiliere-" + city.toLowerCase() + ".jpg";

    const links = [
        {
            title: "Voir nos appartements à vendre à " + city,
            url: "/vente/appartement/" + city.toLowerCase() + "-" + postalCode
        },
        {
            title: "Voir nos maisons à vendre à " + city,
            url: "/vente/maison/" + city.toLowerCase() + "-" + postalCode
        },
        {
            title: "Voir nos appartements à louer à " + city,
            url: "/location/appartement/" + city.toLowerCase() + "-" + postalCode
        },
        {
            title: "Voir nos maisons à louer à " + city,
            url: "/location/maison/" + city.toLowerCase() + "-" + postalCode
        },
    ];

    return (
        <article className="flex flex-col items-center md:min-h-96 md:flex-row relative">
            {position === "left" && !isMobile &&
                <Image className="hidden md:block absolute object-cover w-full h-full rounded-xl -z-10"
                       src={imageSource}
                       alt={"Agence immobilière " + city}/>}
            <div
                className={"flex flex-col h-full md:p-4 w-full md:from-white md:from-50% md:to-85% md:to-transparent " + (position === "left" ? "md:items-end md:bg-gradient-to-l" : "md:items-start md:bg-gradient-to-r")}>
                <div className="w-full md:w-1/2">
                    <h3 className="mb-2 text-2xl md:text-4xl font-bold tracking-tight text-gray-900 text-center">{title}</h3>
                    <p className="mb-3 font-normal text-gray-700">{description}</p>
                    <div className="flex justify-center mb-6">
                        <ul className="text-left text-lg">
                            {links.map((link, index) => (
                                <li key={index}>
                                    <a className="underline hover:text-primary-light"
                                       href={link.url}>{link.title}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div
                        className="flex space-y-4 justify-center mb-6">
                        <ContactModalButton isCTA={true} text="Nous contacter"/>
                    </div>
                    {isMobile && (
                            <Image className="md:hidden object-cover w-full max-w-2xl max-h-96" src={imageSource}
                                   alt={"Agence immobilière " + city}/>
                    )}
                    <div className="text-sm md:text-md italic font-semibold text-primary">
                        {cityDescription}
                    </div>
                </div>
            </div>
            {position === "right" && !isMobile &&
                <Image className="absolute object-cover w-full h-full -z-10 rounded-xl" src={imageSource}
                       alt={"Agence immobilière " + city}/>}
        </article>
    );
}

export default HomeArticle;